// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { Link } from "react-router-dom";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const HomePage = () => {
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <components.HeaderComponent />

      <section className="km-hero">
        <div className="km-hero-photo" />
        <div className="km-hero-scrim" />
        <div className="km-hero-inner">
          <div className="km-hero-eyebrow">
            <span className="dot" /> Внутренний портал предприятия
          </div>
          <h1>Платформа для всех работников АО «Костанайские Минералы»</h1>
          <p>
            Отпуска, расчётные листы, рацпредложения и банк идей — в одном
            месте.
          </p>
          <div className="km-hero-actions">
            <Link to="/video_study" className="btn btn-warning">
              <i className="fa-solid fa-play m-0 p-1" />
              Видео-инструкции
            </Link>
            <Link
              to="/text_study"
              className="btn"
              style={{
                background: "rgba(255,255,255,.1)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,.2)",
              }}
            >
              <i className="fa-solid fa-file-lines m-0 p-1" />
              Текстовые инструкции
            </Link>
          </div>
          <div
            className="mt-3 d-inline-flex align-items-center gap-2"
            style={{ fontSize: "12.5px", color: "#AEB9C7" }}
          >
            <i className="fa-solid fa-circle-info" />
            Первый раз на платформе? Видео «Первый вход в систему» — в
            разделе видео-инструкций выше.
          </div>
        </div>
      </section>

      <main className="m-0 p-0" style={{ overflowX: "hidden" }}>
        <div style={{ padding: "28px 32px 32px" }}>
        <h2 style={{ fontSize: "16px", fontWeight: 700, margin: "0 0 14px" }}>
          Быстрые ссылки
        </h2>
        <div
          className="row row-cols-1 row-cols-md-3 m-0 p-0 g-3"
          style={{ "--bs-gutter-x": "1rem", marginLeft: 0, marginRight: 0 }}
        >
          <div className="m-0 p-0">
            <Link
              to="/salary"
              className="custom-card d-flex align-items-center gap-3 m-0 p-3 text-decoration-none text-dark"
            >
              <span
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  background: "var(--km-blue-pale)",
                  color: "var(--km-blue)",
                  flex: "none",
                }}
              >
                <i className="fa-solid fa-file-invoice-dollar" />
              </span>
              <span>
                <span style={{ display: "block", fontWeight: 700, fontSize: "14px" }}>
                  Расчётный лист
                </span>
                <span style={{ fontSize: "12.5px", color: "var(--km-text-soft)" }}>
                  выгрузка за период
                </span>
              </span>
            </Link>
          </div>
          <div className="m-0 p-0">
            <Link
              to="/vacation"
              className="custom-card d-flex align-items-center gap-3 m-0 p-3 text-decoration-none text-dark"
            >
              <span
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  background: "#FEF4DD",
                  color: "#B07700",
                  flex: "none",
                }}
              >
                <i className="fa-solid fa-umbrella-beach" />
              </span>
              <span>
                <span style={{ display: "block", fontWeight: 700, fontSize: "14px" }}>
                  Данные по отпуску
                </span>
                <span style={{ fontSize: "12.5px", color: "var(--km-text-soft)" }}>
                  выгрузка за период
                </span>
              </span>
            </Link>
          </div>
          <div className="m-0 p-0">
            <Link
              to="/servicerecord"
              className="custom-card d-flex align-items-center gap-3 m-0 p-3 text-decoration-none text-dark"
            >
              <span
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "10px",
                  background: "#E7F5FA",
                  color: "#1A8FB8",
                  flex: "none",
                }}
              >
                <i className="fa-solid fa-id-card-clip" />
              </span>
              <span>
                <span style={{ display: "block", fontWeight: 700, fontSize: "14px" }}>
                  Послужной список
                </span>
                <span style={{ fontSize: "12.5px", color: "var(--km-text-soft)" }}>
                  выгрузка за период
                </span>
              </span>
            </Link>
          </div>
        </div>
        </div>
      </main>
      <components.FooterComponent />
    </div>
  );
};
